<script context="module">
	import { writable } from 'svelte/store'
	import { urlAdmin } from '../../library/scripts/Setup.svelte'
	import { admin } from '../../library/scripts/PhpHandler.svelte'

	//stores for navigation
	export const adminMenu = writable(true)
	export const adminMail = writable(false)
	export const adminEvent = writable(false)
	export const adminGallery = writable(false)

	//store for menu update
	export const adminUpdateFoodsEntry = writable(sessionStorage.getItem('foods'))
	export const adminUpdateDrinksEntry = writable(sessionStorage.getItem('drinks'))
	export const adminUpdateSeasonsEntry = writable(sessionStorage.getItem('seasons'))
	export const adminUpdateRoomsEntry = writable(sessionStorage.getItem('rooms'))
	export const adminUpdateShopEntry = writable(sessionStorage.getItem('shop'))

	// stores for food entries
	export const adminFoodsCategory = writable([])

	// stores for drink entries
	export const adminDrinksCategory = writable([])

	//store for single item updates
	export const SingleItem = writable(false)

	//store for mail stuff
	export const adminSingleReceiver = writable(false)
	export const adminSingleReceiverValue = writable(null)

	//default mailCommand
	export const adminReceiver = writable('admin')

	//update the mailArchive
	export const adminArchiveMail = writable(sessionStorage.getItem('admin_mail'))

	//update the eventArchive
	export const adminArchiveEvent = writable(null)

	//functions to export
	export function check_values(db, values) {
		if (values.name === '') return 'name is empty'
		if (db === 'drinks') {
			if (values.category === '') return 'category is empty'
			if (values.quantity === '') return 'quantity is empty'
			if (values.quantity !== '-') {
				if (!parseFloat(values.quantity)) return 'quantity is not a number'
			}
			if (values.price === '') return 'price is empty'
			if (!parseFloat(values.price)) return 'price is not a number'
		}
		if (db === 'foods') {
			if (values.category === '') return 'category is empty'
			if (values.description === '') return 'add description'
			if (values.price === '') return 'price is empty'
			if (!parseFloat(values.price)) return 'price is not a number'
		}

		if (db === 'rooms') {
			if (values.bedSize === '') return 'enter bed size'
			if (values.description === '') return 'enter description'
			if (!values.image.value) return 'select image'
			if (!parseFloat(values.low)) return 'amount is not a number'
			if (!parseFloat(values.high)) return 'amount is not a number'
		}

		if (db === 'shop') {
			const n = parseInt(values.stock)
			if (values.category === '') return 'add/select category'
			if (values.name === '') return 'enter product name'
			if (values.descShort === '') return 'add a short description'
			if (values.descLong === '') return 'add a long description'
			if (!values.image.value) return 'select image'
			if (values.stock === '') return 'add stock'
			if (!Number.isInteger(n)) return 'stock has wrong number format'
			if (!parseFloat(values.price)) return 'price is not a valid number'
		}

		return true
	}

	export function check_admin_mail_entries(values) {
		if (values.subject === '' || values.subject === null) return 'no subject'
		if (values.salutation === '' || values.salutation === null) return 'no addressing'
		if (values.message === '' || values.message === null) return 'no message'
		return true
	}

	//guesthouse room numbers
	export const ghRoomNumber = writable(1)

	export async function fetch_rooms_from_db() {
		let rooms = []
		const fetchRooms = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'get_rooms',
			}),
		})

		const dataResponse = await fetchRooms.json()

		if (dataResponse.fetch === 0 || !dataResponse.fetch) {
			adminUpdateRoomsEntry.set('[]')
			sessionStorage.setItem('rooms', '[]')
			return
		}

		dataResponse.fetch.forEach((item) => {
			let tmpItem = {
				number: item[0],
				bedSize: item[1],
				guests: item[2],
				description: item[3],
				image: item[4],
				low: item[5],
				high: item[6],
				bookings: item[7],
				currency: item[8],
				breakfast: item[9],
			}

			//add the item at the beginning of the array menu
			rooms.push(tmpItem)
		})

		adminUpdateRoomsEntry.set(JSON.stringify(rooms))
		sessionStorage.setItem('rooms', JSON.stringify(rooms))

		return rooms
	}

	export async function get_active_bookings() {
		const bookings = admin({ cmd: 'get_active_bookings' })
		return bookings
	}

	export async function get_upcoming_bookings() {
		const bookings = admin({ cmd: 'get_upcoming_bookings' })
		return bookings
	}

	export async function get_completed_bookings() {
		const bookings = admin({ cmd: 'get_completed_bookings' })
		return bookings
	}

	export async function get_all_bookings() {
		const bookings = admin({ cmd: 'get_all_bookings' })
		return bookings
	}

	export async function get_old_bookings_pdf(id) {
		const bookings = admin({ cmd: 'get_old_bookings_pdf', id: id })
		return bookings
	}

	export function remove_duplicates(arr) {
		let compaire = []
		let updated = []

		arr.forEach((a) => {
			if (!compaire.includes(a[0])) {
				compaire.push(a[0])
				updated.push(a)
			}
		})

		return updated
	}

	export function sort_array(sortArray) {
		// sort the array
		const sortedData = sortArray.sort((a, b) => a[1] - b[1])
		return sortedData
	}

	export async function change_menuorder(e, dbtable) {
		const newOrder = await admin({
			cmd: 'changeorder',
			category: e,
			dbtable: dbtable,
		})

		return newOrder
	}

	// check if a category exists in array
	export function check_category(category, arr) {
		let categories = []

		arr.forEach((e) => {
			categories.push(e[0])
		})

		if (categories.includes(category)) return true
		return false
	}

	// update categories
	export async function update_categories(db, category, name) {
		const updated = await admin({
			cmd: 'update_categories',
			db: db,
			category: category,
			name: name,
		})

		let updatedCat = remove_duplicates(updated.categories)
		updatedCat = sort_array(updatedCat)

		// set te categories
		if (db === 'drinks') {
			adminDrinksCategory.set(updatedCat)

			// create the new menu
			let menu = []
			updated.menu.forEach((item) => {
				let tmpItem = {
					category: item[0],
					id: item[1],
					name: item[2],
					quantity: item[3],
					price: item[4],
					currency: item[5],
					menuorder: item[6],
				}

				//add the item at the beginning of the array menu
				menu.unshift(tmpItem)
			})

			sessionStorage.setItem('drinks', JSON.stringify(menu))
			adminUpdateDrinksEntry.set(JSON.stringify(menu))
			return true
		}

		if (db === 'foods') {
			adminFoodsCategory.set(updatedCat)

			// create the new menu
			let menu = []
			updated.menu.forEach((item) => {
				let tmpItem = {
					category: item[0],
					id: item[1],
					name: item[2],
					description: item[3],
					price: item[4],
					currency: item[5],
					menuorder: item[6],
				}

				//add the item at the beginning of the array menu
				menu.unshift(tmpItem)
			})

			sessionStorage.setItem('foods', JSON.stringify(menu))
			adminUpdateFoodsEntry.set(JSON.stringify(menu))
			return true
		}
	}
</script>
